<template>
  <router-view />
</template>

<style>
  @import "styles/font.scss";
  @import "styles/main.scss";
</style>
